<template>
	<div class="row">
		<div class="col-xl-6 col-lg-8 col-md-12">
			<UserAppsPanel />
		</div>
		<div class="col-xl-6 col-lg-4 col-md-12">
			<UserAccountPanel />
		</div>
	</div>
</template>
<script>
import UserAppsPanel from '@/components/UserAppsPanel.vue'
import UserAccountPanel from '@/components/UserAccountPanel.vue'

export default {
  name: 'HomePage',
  components: {
    UserAppsPanel,
    UserAccountPanel
  }
}

</script>
